import { SlidersHorizontal } from 'lucide-react'

export function ChainLimitButton({ onClick, disabled, label, testId }: { onClick?: () => void; disabled: boolean; label: string; testId: string }) {
  return onClick ? <button type="button" className="tr-bsb limit" disabled={disabled} onClick={onClick} aria-label={`Limit order for ${label}`} title="Set a limit price, optional SL and target" data-testid={testId}><SlidersHorizontal size={12} /></button> : null
}
